import { render, staticRenderFns } from "./AnimatedHeadingFlip.vue?vue&type=template&id=89b91144&"
import script from "./AnimatedHeadingFlip.vue?vue&type=script&lang=js&"
export * from "./AnimatedHeadingFlip.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedHeadingFlip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports